import React from "react";

import { CircularProgress } from "@material-ui/core";

import style from "../../style.module.css";
import { quotes } from "constants/quotes";

const randomQuoteKey = Math.floor(Math.random() * (quotes.length - 1));

const randomQuote = quotes[randomQuoteKey];

const Loader = (props) => {
  const {
    initialState,
    templateData,
    secondaryDataToLoad,
    loadingTime,
    primaryDataToLoad,
  } = props;
  return (
    <div className={style.loading}>
      <CircularProgress />
      <br />
      <h3>Loading</h3>
      <div>
        {initialState ? "Fetched Host Data" : "Fetching Host Data..."}
        <br />
        {templateData ? "Fetched Template Data" : "Fetching Template Data..."}
        <br />
        {`Fetching other data: ${secondaryDataToLoad.filter(Boolean).length}/${
          secondaryDataToLoad.length
        }`}
        <br />
        {primaryDataToLoad ? "Initialising..." : null}
        {loadingTime > 3 ? (
          <>
            <hr />
            The page is still loading, though it seems to be taking longer than
            usual
          </>
        ) : null}
        {loadingTime > 4 && loadingTime < 14 ? (
          <>
            <hr />
            {randomQuote?.title}&nbsp;-&nbsp;{randomQuote?.author}
          </>
        ) : null}
        {loadingTime > 15 ? (
          <>
            <hr />
            The page has been loading for the last {loadingTime}
            &nbsp; seconds. Kindly try refreshing the page if you are not on a
            slow internet.
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Loader;
